// leaders/tms-detail
import React, { useCallback, useState } from 'react';
import View from 'src/pages/leaders/tms/detail';
import AppRender from 'src/routes/app-render';
import { useForm } from 'src/hooks/use-form';
import { tmsApi } from 'src/api/tms/vm-view';

const Page = () => {
  const { handleNavigate, itemNavigate } = useForm();

  const [data, setData] = useState();
  const fetchData = useCallback(async () => {
    if(itemNavigate){
      tmsApi.getDetail(
        itemNavigate,
        (result) => {
          // Handle evidences
          // sortEvidences(result);

          setData(result);
        }
      );
    }
  }, []);

  function sortEvidences(result){
    if (result.evidences) {
      // Sort evidences by timestamp
      const sortedEvidences = result.evidences.sort((a, b) => {
        const hasTimestampA = a.timestamp ? 1 : 0;
        const hasTimestampB = b.timestamp ? 1 : 0;

        // Move items with timestamp to the front
        if (hasTimestampA !== hasTimestampB) {
          return hasTimestampB - hasTimestampA;
        }

        // Sort by timestamp if both have it
        if (a.timestamp && b.timestamp) {
          return Number(a.timestamp) - Number(b.timestamp);
        }

        // Otherwise, keep the order as is
        return 0;
      });

      // Extract the first and second items
      const first = sortedEvidences[0];
      const second = sortedEvidences[1];

      result.checkinBy = Number(first?.timestamp || 0);
      result.checkoutBy = Number(second?.timestamp || 0);
    }
  }

  return (
    <AppRender apiCall={fetchData}>
      {data && <View onNavigate={handleNavigate} item={data} />}
    </AppRender>
  );
};

export default Page;
